(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  const root = document.querySelector('[data-nf-popup]');
  if (root) {
    const key = 'nf-welcome-popup';
    const open = () => { root.hidden = false; };
    const close = () => {
      root.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (error) {}
    };
    root.querySelectorAll('[data-nf-popup-close]').forEach((el) => el.addEventListener('click', close));
    const params = new URLSearchParams(location.search);
    if (params.get('customer_posted') === 'true' || root.querySelector('.nf-popup__success')) {
      open();
      try { localStorage.setItem(key, '1'); } catch (error) {}
    } else {
      let seen = false;
      try { seen = localStorage.getItem(key) === '1'; } catch (error) {}
      if (!seen) setTimeout(open, 1200);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.nf-product').forEach((section) => {
      const select = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const button = section.querySelector('[data-add-button]');
      const thumbs = section.querySelectorAll('.nf-product__thumb[href^="#"]');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          const target = section.querySelector(thumb.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      if (select && price && button) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          const available = option.dataset.available === 'true';
          price.textContent = option.dataset.price;
          button.disabled = !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
